module.exports = __webpack_public_path__ + "static/img/Bintro3.36c3e1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/Bintro3.png
// module id = NuHp
// module chunks = 1